import { TrayType } from 'components/organisms/EditTrayModal/EditTrayModal.types'

export const getTrayTypeFromJSONFileName = (fileName: string): TrayType => {
  switch (fileName) {
    case 'Stryker_1.7_Mid_Face_top':
      return 'stryker middle face'
    case 'Stryker_1.2_Upper_Face':
      return 'stryker upper face'
    case 'Zimmer_curved_rods':
      return 'zimmer curved rods'
    case 'Zimmer_pedicle_screws':
      return 'zimmer biomet vitality polyaxial screw caddy'
    case 'Zimmer_transverse_connectors':
      return 'zimmer adjustable transverse connector'
    case 'Zimmer_standard_closure_tops':
      return 'zimmer standard closure tops'
    case '2.0_Mini_Monster_SC':
      return '2.0 mini monster'
    case '2.5_Mini_Monster_SC':
      return '2.5 mini monster'
    case '3.0_Mini_Monster_SC':
      return '3.0 mini monster'
    case 'Headless_Compression_Screw_Rack':
      return 'headless compression screw rack'
    case 'QuickFix_Cannulated_Screw_System':
      return 'quickfix cannulated screw system'
    case 'MFTR4TP':
      return 'mini frag tray rack 4 top (plates)'
    case 'MFTR2TRP':
      return 'mini frag tray rack 2 top (plates)'
    case 'MFTR4MP':
      return 'mini frag tray rack 4 main (plates)'
    case 'MAACPS1LPC':
      return 'maxan anterior cervical plate system 1 level plates caddy'
    case 'MAACPS2LPC':
      return 'maxan anterior cervical plate system 2 level plates caddy'
    case 'MAACPS3LPC':
      return 'maxan anterior cervical plate system 3 level plates caddy'
    case 'MAACPSSC':
      return 'maxan anterior cervical plate system screw caddy'
    case 'Zimmer_Extra_Space_Test':
      return 'zimmer extra space test'
    case 'Alif_Trial_Set':
      return 'alif trial set'
    case 'Hedron_IA_Locking_Screws':
      return 'hedron ia locking screws'
    case '24x30mm_Spacers':
      return '24x30mm spacers'
    case '26x34mm_Spacers':
      return '26x34mm spacers'
    case '29x39mm_Spacers':
      return '29x39mm spacers'
    case 'Lumbar_Anchor_Set':
      return 'lumbar anchor set'
    case 'Stryker_2.0MP_Upper_Plates':
      return 'stryker 2.0 mp plates upper tray'
    case 'Stryker_2.0MP_Lower_Plates':
      return 'stryker 2.0 mp plates lower tray'
    case 'KLS_Martin_1.5mm_Lindorf_Orthognathic_Module_Subtray_1':
      return 'kls martin 1.5mm lindorf orthognathic module subtray 1'
    case 'KLS_Martin_1.5mm_Lindorf_Orthognathic_Module_Subtray_2':
      return 'kls martin 1.5mm lindorf orthognathic module subtray 2'
    case 'KLS_Martin_1.5mm_Micro_Module_Regular_Trauma_PCOMS':
      return 'kls martin 1.5mm micro module regular trauma pcoms'
    case 'KLS_Martin_2.0_Micro_Module_Regular_Trauma_PCOMS':
      return 'kls martin 2.0 micro module regular trauma pcoms'
    case 'Globus_Xtend_Cervical_Plate_Set':
      return 'globus xtend cervical plate set'
    case 'Globus_Xtend_Screw_Set':
      return 'globus xtend screw set'
    default:
      return 'stryker screw caddy'
  }
}
